<template>
    <div>
			<title-btn 
				title="系统通知"
				btnTitle="+新建通知"
				v-on:click="isShowInform(0,0,'新建通知')"
			/>
	    <el-form :inline="true" :model="formInline" class="form-inline">
				<el-form-item label="通知标题:">
					<el-input v-model="formInline.user" placeholder="请输入通知标题"></el-input>
				</el-form-item>
				<el-form-item label="通知人员:">
					<el-select v-model="formInline.region" placeholder="请选通知人员">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item>
		</el-form>
		<div class="header">
			<el-form :inline="true" :model="formInline" class="form-inline">
				<el-form-item label="时间范围">
				    <el-col :span="11">
				      <el-date-picker :clearable="false"  type="date" placeholder="选择查询起始时间" v-model="formInline.date1" style="width: 100%;"></el-date-picker>
				    </el-col>
				    <el-col :span="2" style="text-align: center;">  -</el-col>
				    <el-col :span="11">
				      <el-date-picker :clearable="false"  type="date" placeholder="选择查询结束时间" v-model="formInline.date2" style="width: 100%;"></el-date-picker>
				    </el-col>
				 </el-form-item>
			</el-form> 
			<div>
				 <el-button type="primary" style="height: 35px;line-height: 10px;" @click="searchInfo">查询</el-button>
				  <el-button type="info" style="height: 35px;line-height: 10px;">重置</el-button>
			</div>
		</div>
		 <el-table
		    :data="tableData"
		    stripe
		    :cell-style="cell"
        :header-cell-style="cell"
		    style="width: 100%;">
		    <el-table-column
		      prop="caption"
		      label="通知标题"
		      width="180">
		    </el-table-column>
				<!-- <el-table-column
		      prop="content"
		      label="通知内容"
		      width="0">
		    </el-table-column> -->
		    <el-table-column
		      prop="range"
		      label="通知人员"
		      width="180">
		    </el-table-column>
		    <el-table-column
		      prop="date"
		      label="发表时间">
		    </el-table-column>
		    <el-table-column
		      label="操作" style="text-align: center;">
		      <template slot-scope="scope">
		        <el-button @click="seeContent(scope.$index, scope.row)" type="text" size="small" style="color: #aaa;">查看</el-button>
		        <el-button @click="isShowInform(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
		        <el-button @click="handleDelete" type="text" size="small" style="color: red;">删除</el-button>
		      </template>
		    </el-table-column>
		 </el-table>
		 <div class="pageWrap">
			<el-pagination
				:current-page.sync="currentPage"
				:page-size="pageSize"
				layout="prev, pager, next, jumper"
				:total="30">
			</el-pagination>
		 </div>
		 <!-- 弹出新建内容弹框 -->
		 <add-inform
		 	:visible="isShowNewInform"
			:title="informTitle"
			v-on:cancel="cancelBox"
			v-on:sure="sureBox"
		 />
    </div>
</template>

<script>
import TitleBtn from "@/components/TitleButton";
import AddInform from "./AddInform";
import { compareTime } from '@/utils'
export default {
  name: "",
  components: {
    TitleBtn,
    AddInform
  },
  data() {
    return {
      isShowNewInform: false,
      isShowDelete: true,
			informTitle: "编辑通知",
			currentPage:2,
			pageSize: 20,
      formInline: {
        user: "",
        region: "",
        date1: "",
        date2: ""
      },
      tableData: [
        {
          caption: "停电通知",
          content: "要停电了",
          range: "所有人员",
          date: "2017-09-18 19:10"
        },
        {
          caption: "放假通知",
          content: "要放假了",
          range: "加优人员",
          date: "2017-09-18 19:10"
        }
      ]
    };
  },
  methods: {
    seeContent(index, row) {
      let { caption, content } = row;
      this.$alert(content, caption, {
        confirmButtonText: "确定"
        // callback: action => {
        //   this.$message({
        //     type: "info",
        //     message: `action: ${action}`
        //   });
        // }
      });
    },
    handleDelete() {
      if (this.isShowDelete) {
        this.isShowDelete = !this.isShowDelete;
        this.$confirm("确认删除此通知吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          })
          .finally(() => {
            this.isShowDelete = !this.isShowDelete;
          });
      }
    },
    isShowInform(index, row, role = "编辑通知") {
      this.informTitle = role;
      this.isShowNewInform = true;
    },
    cancelBox() {
      this.isShowNewInform = false;
    },
    sureBox() {
      this.isShowNewInform = false;
    },
    cell() {
      return { textAlign: "center" };
		},
		searchInfo(){
			let {date1,date2} = this.formInline;
			let flag = compareTime(date1,date2)
			if(flag){
				//@todo 查询数据
			}else{
				this.$notify({
            title: "提示",
            message:'请正确选择时间',
            type:'warning',
            duration: 800
          });
			}
		}
  }
};
</script>
<style lang='scss' scoped>
	.header {
		display: flex;
		justify-content: space-between;
	}
	.pageWrap{
		margin-top: 20px;
		.el-pagination{
			text-align: center;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/system/index.vue